import ProppingItem from '../ProppingItem';
import proppingService from '../../services/propping';
import { getProppingBounds } from '../../services/products/models';
import tacHelpers from '../../state/tac/tacHelpers';

export default class ElvarliProppingItem extends ProppingItem {
  getSectionSprite(section) {
    return (
      this.app.itemContainer.getSprite(section.itemid) ||
      this.app.itemContainer.children.find(
        sprite => sprite.item.itemid === section.itemid
      )
    );
  }

  getResourceName() {
    const { item, parentItem } = this;

    const proppingBounds = getProppingBounds(item);
    if (!this.shouldShowPropping(proppingBounds)) return item.id;

    const proppingItem = this.item;
    const section = tacHelpers.getTopAncestor(this.app.tac, parentItem);

    const sectionSprite = this.getSectionSprite(section);

    const pickedPropping = proppingService.pickPropping({
      isDynamic: true,
      tac: this.app.itemContainer ? this.app.itemContainer.tac : this.app.tac,
      item: proppingItem,
      parentItem,
      section: sectionSprite,
    });

    const pickedProppingBound = proppingBounds[pickedPropping - 1];
    const oldProppingBound = item.propping
      ? proppingBounds[item.propping - 1]
      : null;
    const pickedProppingHasOldHeight =
      pickedProppingBound.size.height === oldProppingBound?.size.height;

    /* If the newly picked propping has the same height as before, we want to
       keep the old one, so that the propping won't cycle through randomly
       chosen variants of the same size when moving things on the scene. */
    if (!pickedProppingHasOldHeight) item.propping = pickedPropping;

    const resourceName = `${item.id}_propping_${item.propping}`;

    return resourceName;
  }
}
